import React from 'react';
import { Box } from '@mui/material';
import { formatListDate } from '../../../common/helpers';
import { ActionsMenu } from './ActionsMenu';
import { TitleIcon } from '../../TitleIcon';
import { getStatusClass } from '../../helpers/resourceStatus';

/**
 * Builds the column definitions for ResourcesTable.
 * @param {Object} params Column configuration
 * @param {String} params.id ID prefix for generated element IDs
 * @param {String} params.titleHeader Header shown above the title column
 * @param {Function} params.onEdit Omit to hide Edit from the row menu
 * @param {Function} params.onDelete Called with the row to delete
 * @returns {Array<Object>} The DataGrid column definitions
 */

export const getColumns = ({ id, titleHeader, onEdit, onDelete }) => [
  {
    field: 'title',
    headerName: titleHeader,
    flex: 1,
    cellClassName: 'titleCell',
    renderHeader: () => <strong className="resourceHeaderTitle">{titleHeader}</strong>,
    renderCell: ({ row }) => (
      <Box className="resourceTitleCell">
        <TitleIcon status={row.status} />
        {/*
          Cut by the column rather than by a character count: the cell is as
          wide as the table makes it, so CSS is what knows where the name has
          to stop. The whole name stays in the DOM for a screen reader, and
          `title` offers it to the eye on hover.
        */}
        <span className={`resourceTitle ${getStatusClass(row.status)}`} title={row.title}>
          {row.title}
        </span>
      </Box>
    ),
  },
  {
    field: 'createdAt',
    headerName: 'Date',
    width: 160,
    cellClassName: ({ row }) => `dateCell ${getStatusClass(row.status)}`.trim(),
    valueFormatter: (value) => formatListDate(value),
  },
  {
    field: 'actions',
    headerName: '',
    width: 60,
    sortable: false,
    renderCell: ({ row }) => <ActionsMenu id={id} row={row} onEdit={onEdit} onDelete={onDelete} />,
  },
];
